import React, { useCallback, useEffect, useMemo, useState } from "react";
import Students from "./components/Students";
import Search from "./components/Search";
import getAverage from "./helpers/getAverage";
import "./index.css";

const searchInputs = [
  { inputField: "name", value: "" },
  { inputField: "tag", value: "" },
];
const appContainerStyle = {
  maxWidth: "50em",
  margin: "auto",
  background: "rgb(241, 240, 240)",
  padding: "2.5em",
};
const appInnerContainerStyle = {
  background: "#ffffff",
  padding: "1em",
  borderRadius: ".8em",
  minHeight: "100vh",
};
const App = () => {
  const [url, setUrl] = useState(
    "https://api.hatchways.io/assessment/students"
  );
  const [students, setStudents] = useState([]);
  const [nameInput, setNameInput] = useState("");
  const [tagInput, setTagInput] = useState("");

  const getStudentsProfiles = useMemo(async () => {
    return await fetch(url)
      .then((res) => res.json())
      .then((data) => {
        return data;
      }).catch({ message: "Unable to fetch data from the server. Please try again"});
  }, [url]);

  const addNewTag = useCallback((newTag, studentId) => {
    const studentsClone = [
      ...students.map((student) => {
        if (student.id === studentId) student.tags.push(newTag);
        return student;
      }),
    ];
    setStudents(studentsClone);
  }, [students]);

  useEffect(() => {
    getStudentsProfiles.then((data) => {
      if(data.message) return alert(data.message);
      const studentsWithTagAndAvgProp = [
        ...data.students.map((student) => {
          student.tags = [];
          student.averageScore = getAverage(student.grades);
          return student;
        }),
      ];

      setStudents(studentsWithTagAndAvgProp);
    });
  }, [getStudentsProfiles]);

  return (
    <div style={appContainerStyle}>
      <div style={appInnerContainerStyle}>
        {searchInputs.map((input) => (
          <Search
          students={students} nameInput={nameInput} tagInput={tagInput}
            key={input.inputField}
            inputField={input.inputField}
            setNameInput={setNameInput}
            setTagInput={setTagInput}
          />
        ))}
        <Students students={students} nameInput={nameInput} tagInput={tagInput} addNewTag={addNewTag}/>
      </div>
    </div>
  );
};
export default App;
